import axios from 'axios';

class PdfExportService {
    constructor() {
        this.maxRetries = 5;
        this.retryDelay = 7000;
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async getPdfUrl(id) {
        const response = await axios.get(`/api/pdf_url/${id}`);
        return response.data;
    }

    async waitForPdfGeneration(id) {
        let retries = 0;
        let url = null;

        while (retries < this.maxRetries && !url) {
            try {
                const data = await this.getPdfUrl(id);
                url = data.url;

                if (url) {
                    return url;
                }
            } catch (error) {
                const errorType = error.response && error.response.data && error.response.data.type
                    ? error.response.data.type
                    : null;

                if (errorType !== 'PdfNotReadyException') {
                    throw new Error('Não foi possível gerar seu PDF.');
                }

                retries++;

                if (retries < this.maxRetries) {
                    await this.sleep(this.retryDelay);
                }
            }
        }

        if (!url) {
            throw new Error('Não foi possível gerar seu PDF.');
        }

        return url;
    }

    downloadFile(url, filename) {
        const finalFilename = filename || `historico_${Date.now()}.pdf`;
        const link = document.createElement('a');
        link.href = url;
        link.download = finalFilename;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    async generatePdf(endpoint, params) {
        const response = await axios.get(endpoint, { params });
        const pendingId = response.data && response.data.data && response.data.data.id
            ? response.data.data.id
            : null;

        if (!pendingId) {
            throw new Error('Erro ao iniciar geração do PDF');
        }

        return pendingId;
    }

    async downloadPdf(endpoint, params) {
        const pendingId = await this.generatePdf(endpoint, params);
        const fileUrl = await this.waitForPdfGeneration(pendingId);
        this.downloadFile(fileUrl);

        return fileUrl;
    }

    async sendPdfEmail(endpoint, params) {
        const response = await axios.get(endpoint, { params });
        return response.data;
    }
}

export default new PdfExportService();
